// extracted by mini-css-extract-plugin
export var menuIcon = "_sw-0";
export var menuIconInline = "_sw-1";